import React from 'react';
import SoilList from '@/page/Soil/soil-list';
import SoilProfile from '@/page/Soil/soil-profile';
import UserManagement from '@/page/Soil/user-management';
import SoilAnalyses from '@/page/Soil/soil-analyses';
import RefrenceData from '@/page/Soil/reference-data';
import TemplateUpdate from '@/page/Soil/soil-templateUpdate';
import NewTemplateUpdate from '@/page/Soil/soil-new-templateUpdate';
import ViewTemplate from '@/page/Soil/soil-veiw-template';
import WeatherQuery from '@/page/WeatherStation/weather-query';
import Home from '@/page/Common/home';
import Feedback from '@/page/Common/feedback';
import WeatherQueryHistory from '@/page/WeatherStation/weather-query-history';
import SoilHistory from '@/page/Soil/soil-history';
import AgrialertUserManagement from '@/page/Agrialert/user-management';
import AgrialertTemplateManagement from '@/page/Agrialert/template-management';

const routers = [
    {
        path: '/',
        sidebar: (key: string) => <Home key={key} />
    },
    {
        path: '/soilhub',
        sidebar: (key: string) => <SoilList key={key} />
    },
    {
        path: '/soilhub/*',
        sidebar: (key: string) => <SoilList key={key} />
    },
    {
        path: '/profile',
        sidebar: (key: string) => <SoilProfile key={key} />
    },
    {
        path: '/userManagement',
        sidebar: (key: string) => <UserManagement key={key} />
    },
    {
        path: '/analyses',
        sidebar: (key: string) => <SoilAnalyses key={key} />
    },
    {
        path: '/templateUpdate',
        sidebar: (key: string) => <TemplateUpdate key={key} />
    },
    {
        path: '/newTemplateUpdate',
        sidebar: (key: string) => <NewTemplateUpdate key={key} />
    },
    {
        path: '/refrenceData',
        sidebar: (key: string) => <RefrenceData key={key} />
    },
    {
        path: '/viewTemplate',
        sidebar: (key: string) => <ViewTemplate key={key} />
    },
    {
        path: '/weatherQuery/:id',
        sidebar: (key: string) => <WeatherQuery key={key} />
    },
    {
        path: '/weatherQuery',
        sidebar: (key: string) => <WeatherQuery key={key} />
    },
    {
        path: '/home',
        sidebar: (key: string) => <Home key={key} />
    },
    {
        path: '/feedback',
        sidebar: (key: string) => <Feedback key={key} />
    },
    {
        path: '/WeatherQueryHistory',
        sidebar: (key: string) => <WeatherQueryHistory key={key} />
    },
    {
        path: '/soilHistory',
        sidebar: (key: string) => <SoilHistory key={key} />
    },
    {
        path: '/agrialert/userManagement',
        sidebar: (key: string) => <AgrialertUserManagement key={key} />
    },
    {
        path: '/agrialert/template',
        sidebar: (key: string) => <AgrialertTemplateManagement key={key} />
    },
];


export default routers;